export default __webpack_public_path__ + "static/media/ultrasonicToki@2x.9f46e872.png";